export const SUPPORTED_LANGUAGES = ['es', 'en', 'de', 'fr', 'nl', 'he']
export const DEFAULT_LANGUAGE = 'en'

export function getValidLanguage(lng) {
  if (!lng) return DEFAULT_LANGUAGE

  let normalized = lng.replace('_', '-').split('-')[0].toLowerCase()

  return SUPPORTED_LANGUAGES.includes(normalized)
    ? normalized
    : DEFAULT_LANGUAGE
}